import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "VisaContent" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "VisaHeader" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" If you’re ")
const _hoisted_6 = { class: "VisaSection" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "Header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "HeaderIcon lnr-calendar-full" })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "List" }
const _hoisted_9 = { class: "VisaSection" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "Header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "HeaderIcon lnr-bag-coins" })
], -1 /* HOISTED */)
const _hoisted_11 = { class: "List" }
const _hoisted_12 = { class: "VisaSection" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "Header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "HeaderIcon lnr-profile" })
], -1 /* HOISTED */)
const _hoisted_14 = { class: "List" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "VisaDisclaimer" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "DisclaimerHeader" }, "Disclaimer"),
  /*#__PURE__*/_createElementVNode("p", { class: "DisclaimerText" }, " The information about visa is true and complete to the best of our knowledge. All recommendations are made without guarantee on the part of the author or publisher. The author and publisher deny any liability in connection with the use of this information. ")
], -1 /* HOISTED */)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionContent = _resolveComponent("SectionContent")!
  const _component_NoVisaRequired = _resolveComponent("NoVisaRequired")!
  const _component_NoVisaInformation = _resolveComponent("NoVisaInformation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.visa !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.visa.isVisaRequired)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", null, "Student visas for " + _toDisplayString(_ctx.destinationCountryName), 1 /* TEXT */),
                  _createElementVNode("p", null, [
                    _hoisted_5,
                    _createElementVNode("button", {
                      class: "Textlink",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLocalizationSettings()))
                    }, "from " + _toDisplayString(_ctx.originCountryName), 1 /* TEXT */),
                    _createTextVNode(", you’ll need to apply for a visa to study in " + _toDisplayString(_ctx.destinationCountryName) + ". The following information is taken from embassy and consulate websites. The student visa that you need to enroll in a complete degree programme in " + _toDisplayString(_ctx.destinationCountryName) + " is displayed below. ", 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("h3", null, _toDisplayString(_ctx.visa.name), 1 /* TEXT */),
                _createElementVNode("section", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("ul", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.time, (section, index) => {
                      return (_openBlock(), _createBlock(_component_SectionContent, {
                        key: index,
                        content: section
                      }, null, 8 /* PROPS */, ["content"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _createElementVNode("section", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("ul", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fees, (section, index) => {
                      return (_openBlock(), _createBlock(_component_SectionContent, {
                        key: index,
                        content: section
                      }, null, 8 /* PROPS */, ["content"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _createElementVNode("section", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("ul", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.more, (section, index) => {
                      return (_openBlock(), _createBlock(_component_SectionContent, {
                        key: index,
                        content: section
                      }, null, 8 /* PROPS */, ["content"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _hoisted_15
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_NoVisaRequired)
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_NoVisaInformation)
        ]))
  ]))
}